var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessenger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 11.64C0 4.953 5.241 0 12 0C18.759 0 24 4.956 24 11.643C24 18.33 18.759 23.283 12 23.283C10.785 23.283 9.621 23.121 8.526 22.821C8.313 22.764 8.085 22.779 7.884 22.869L5.502 23.919C5.35814 23.9825 5.20089 24.0096 5.04408 23.9981C4.88726 23.9865 4.73569 23.9367 4.60267 23.8528C4.46965 23.769 4.35926 23.6537 4.2812 23.5172C4.20314 23.3808 4.15981 23.2272 4.155 23.07L4.089 20.934C4.083 20.67 3.963 20.424 3.768 20.25C1.434 18.162 0 15.138 0 11.64ZM8.31901 9.45301L4.79401 15.045C4.45501 15.582 5.11501 16.185 5.61901 15.801L9.40501 12.927C9.52958 12.8324 9.68158 12.7809 9.83801 12.7804C9.99444 12.7798 10.1468 12.8303 10.272 12.924L13.077 15.027C13.276 15.1764 13.5037 15.283 13.746 15.3399C13.9882 15.3969 14.2395 15.403 14.4842 15.3579C14.7289 15.3128 14.9616 15.2174 15.1676 15.0779C15.3736 14.9383 15.5484 14.7575 15.681 14.547L19.209 8.95801C19.545 8.42101 18.885 7.81501 18.381 8.19901L14.595 11.073C14.4704 11.1676 14.3184 11.2191 14.162 11.2196C14.0056 11.2202 13.8532 11.1698 13.728 11.076L10.923 8.97301C10.7241 8.82359 10.4963 8.71704 10.2541 8.66009C10.0119 8.60314 9.76047 8.59702 9.51578 8.64213C9.27109 8.68723 9.0384 8.78258 8.83242 8.92215C8.62643 9.06171 8.45162 9.24247 8.31901 9.45301Z",
    fill: "#282B59"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessenger);
export default __webpack_public_path__ + "static/media/messenger.fe78834c944649118f966e7c4647ae61.svg";
export { ForwardRef as ReactComponent };